import { httpPost } from "../axios/index";
import wx from "weixin-js-sdk";
export default function share(params) {
    //获取当前的url
    let currentUrl = window.location.href.split("#")[0];
    httpPost("/share/signature", { url: currentUrl }).then(res => {
        if (res.code === 1) {
            wx.config({
                debug: false,
                appId: res.data.appId,
                timestamp: res.data.timestamp,
                nonceStr: res.data.nonceStr,
                signature: res.data.signature,
                jsApiList: [
                    "updateAppMessageShareData",
                    "updateTimelineShareData",
                    "onMenuShareTimeline",
                    "onMenuShareAppMessage"
                ]
            });
            wx.ready(function () {
                function success() { }
                console.log(params.share_title)
                wx.updateAppMessageShareData({
                    title: params.share_title,
                    desc: params.share_description,
                    link: currentUrl,
                    imgUrl: params.share_img,
                    success: function () {
                        // 设置成功
                    }
                });
                wx.updateTimelineShareData({
                    title: params.share_title,
                    desc: params.share_description,
                    link: currentUrl,
                    imgUrl: params.share_img,
                    success: function () {
                        // 设置成功
                    }
                });
                //分享到 朋友圈
                wx.onMenuShareTimeline({
                    title: params.share_title,
                    desc: params.share_description,
                    link: currentUrl,
                    imgUrl: params.share_img,
                    success: function () {
                        // user_share(1);
                    },
                    cancel: function () {
                        // 用户取消分享后执行的回调函数
                        //				alert('分享到 朋友圈'+'失败');
                    }
                });

                //分享给 朋友
                wx.onMenuShareAppMessage({
                    title: params.share_title,
                    desc: params.share_description,
                    link: currentUrl,
                    imgUrl: params.share_img,
                    success: function () {
                        // user_share(2);
                    },
                    cancel: function () {
                        // 用户取消分享后执行的回调函数
                        // alert("分享到 朋友" + "失败");
                    }
                });


            });
        }
    });
}